import $ from 'jquery';

/**
 * Scroll-driven effects: the split panels that slide apart while the block
 * scrolls through the viewport (.animazione, with and without .ferma) and the
 * parallax images (.img-parallax). Home, tailored pages and several landings.
 */
export function initScrollAnimations() {
    $(window).scroll(function () {
        $('.animazione:not(.ferma)').each(function (index, element) {
            animaBoxScroll(element);
        });
        $('.animazione.ferma:not(.landing-lancio)').each(function (index, element) {
            animaBoxScrollferma(element);
        });
        $('.img-parallax').each(function (index, element) {
            animaParallasse(element);
        });
    });

    window.addEventListener('resize', function () {
        $('.animazione:not(.ferma)').each(function (index, element) {
            animaBoxScroll(element);
        });
        $('.animazione.ferma:not(.landing-lancio)').each(function (index, element) {
            animaBoxScrollferma(element);
        });
    });

    $('.animazione:not(.ferma)').each(function (index, element) {
        animaBoxScroll(element);
    });
    $('.animazione.ferma:not(.landing-lancio)').each(function (index, element) {
        animaBoxScrollferma(element);
    });
}

function animaParallasse(element) {
    const container = $(element);

    let hT = container.offset().top,
        wH = $(window).height(),
        wW = $(window).width(),
        wS = $(window).scrollTop();

    if (hT < wS + wH) {
        let spazio = wH - 150;
        if (wW <= 991) {
            spazio = wH - 74;
        }
        let posizione = wS + wH - hT;
        $(container).find('img').each(function (i, e) {
            let speed = $(e).data('speed');
            if (speed) {
                let totale = wH * speed;
                if (wW <= 991) {
                    totale = (wH * speed) / 2;
                }
                let move = totale * (spazio - posizione) / spazio;
                $(e).css('transform', 'translateY(' + (move) + 'px)');
            }
        });
    }
}

function animaBoxScroll(element) {
    const container = $(element);
    const panelleft = container.find('.panel-left-animazione');
    const panelright = container.find('.panel-right-animazione');
    const panelcontainer = container.find('.container-animazione');
    const imgLeft = panelleft.find('.img-animata');
    const imgRight = panelright.find('.img-animata');

    let hT = container.offset().top,
        hH = container.outerHeight(),
        wH = $(window).height(),
        wW = $(window).width(),
        wS = $(window).scrollTop();

    let header_height = 150;
    if (wW <= 991) {
        header_height = 74;
    }

    //0%
    if ((wS + header_height) <= Math.round(hT)) {
        panelleft.css('top', '0px');
        panelleft.css('position', 'absolute');

        panelright.css('top', '0px');
        panelright.css('position', 'absolute');

        panelcontainer.css('top', '0px');
        panelcontainer.css('position', 'relative');
    }

    if (((wS + header_height) > Math.round(hT)) && ((wS + header_height) < (hT + hH))) {
        let percent = (wS + header_height - Math.round(hT)) * 100 / Math.round(wH);

        panelleft.css('transform', 'translateX(' + '-' + percent + '%)');
        panelleft.css('top', header_height + 'px');
        panelleft.css('position', 'fixed');

        panelright.css('transform', 'translateX(' + percent + '%)');
        panelright.css('top', header_height + 'px');
        panelright.css('position', 'fixed');

        panelcontainer.css('top', header_height + 'px');
        panelcontainer.css('position', 'fixed');

        imgLeft.each(function (i, e) {
            let easing = $(e).data('animate');
            $(e).css('transform', 'translateX(' + '-' + (percent * easing) + '%)');
        });

        imgRight.each(function (i, e) {
            let easing = $(e).data('animate');
            $(e).css('transform', 'translateX(' + (percent * easing) + '%)');
        });
    }

    //100%
    if ((wS + header_height) >= (Math.round(hT) + (Math.round(hH) / 2))) {
        panelleft.css('top', '0px');
        panelleft.css('position', 'absolute');

        panelright.css('top', '0px');
        panelright.css('position', 'absolute');

        panelcontainer.css('top', (Math.round(hH) / 2) + 'px');
        panelcontainer.css('position', 'relative');
    }
}

function animaBoxScrollferma(element) {
    const container = $(element);
    const panelleft = container.find('.panel-left-animazione');
    const panelright = container.find('.panel-right-animazione');
    const panelcontainer = container.find('.container-animazione');

    let hT = container.offset().top,
        hH = container.outerHeight(),
        wW = $(window).width(),
        wS = $(window).scrollTop();

    let header_height = 150;
    if (wW <= 991) {
        header_height = 74;
    }

    //0%
    if ((wS + header_height) <= Math.round(hT)) {
        panelleft.css('top', '0px');
        panelleft.css('position', 'absolute');

        panelright.css('top', '0px');
        panelright.css('position', 'absolute');

        panelcontainer.css('top', '0px');
        panelcontainer.css('position', 'relative');
    }

    if (((wS + header_height) > Math.round(hT)) && ((wS + header_height) < (hT + hH))) {
        panelleft.css('top', header_height + 'px');
        panelleft.css('position', 'fixed');

        panelright.css('top', header_height + 'px');
        panelright.css('position', 'fixed');

        panelcontainer.css('top', header_height + 'px');
        panelcontainer.css('position', 'fixed');

        panelleft.find('.row').css('position', 'relative');
        panelleft.find('.row').css('min-height', 'auto');

        panelright.find('.row').css('position', 'relative');
        panelright.find('.row').css('min-height', 'auto');
    }

    //100%
    if ((wS + header_height) >= (Math.round(hT) + (Math.round(hH) / 2))) {
        panelleft.css('top', '0px');
        panelleft.css('position', 'absolute');

        panelright.css('top', '0px');
        panelright.css('position', 'absolute');

        panelleft.find('.row').css('bottom', '0px');
        panelleft.find('.row').css('position', 'absolute');
        panelleft.find('.row').css('min-height', '100vh');

        panelright.find('.row').css('bottom', '0px');
        panelright.find('.row').css('position', 'absolute');
        panelright.find('.row').css('min-height', '100vh');

        panelcontainer.css('top', (Math.round(hH) / 2) + 'px');
        panelcontainer.css('position', 'relative');
    }
}
